module.exports = __webpack_public_path__ + "fonts/Prompt-Regular.16b4ce72.ttf";